import * as React from "react";
import { Header } from "../header/Header";
import { LoginForm } from "./LoginForm";
import { makeStyles } from "@fluentui/react-components";
const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
});
export const Login = () => {
  const styles = useStyles();
  return (
    <div className={styles.root}>
      <Header />
      <LoginForm />
    </div>
  );
};
